// import { firebase, googleAuthProvider } from '../firebase/firebase';
import axios from 'axios';
import isEmpty  from 'lodash/isEmpty';
import { history }  from '../routers/AppRouter'
import { picAppError, clearPicAppError } from './picapp';
import { startDeleteContacts, updateContacts } from './contacts';
import getAppConfigParm  from '../config/AppConfig';
import PicPostRequest from '../apis/PicPostRequest';
// import { dispatch } from 'react-redux';
import { prtStart, prtInput, prtMsg, prtVar }  from '../utils/prt';

const FNAME = "participant.js";
const TRACE = true;

// Async action that kicks off a standard action to intialize redux store
export const startGetParticipants = (fromPage) => {
    //TRACE &&prtStart(FNAME, "startGetParticipants")
    //TRACE &&prtInput("fromPage", fromPage);

    return (dispatch, getState ) => {
        // getEventParticipants = () => {
        let self = this;
        // Pull out x-auth token ; server uses it to obtain user email
        let userToken = getState().auth.token;
        // Pull out event id
        let event_id = getState().event.active._id;
      
        /*Construct url for api call and set up header */
        let url    = getAppConfigParm("picUrl") + `/event/${event_id}/participants`; 
        let header = getAppConfigParm("axiosConfig", userToken);
        // let header =  { 
        //     headers: { 'x-auth': userToken,  'Content-Type': 'text/plain' }
        // }
        // /* Make api call to delete token from database */
        axios.get(url, header)
            .then(function (response) {
            let participants = response.data.participants || [];
            //TRACE &&prtMsg("Returned list of participants below");
            //TRACE &&prtVar("participants", JSON.stringify(participants,null,2));
            /* If  being called from PicInvites apge set isChecked to true. If called from PicPeople, set to false */
            let updatedParticipants = [];
            if (fromPage === "PicInvites") {
                updatedParticipants = participants.map(participant  => { 
                    if (!participant.sentdate) {
                        participant.isChecked = true; 
                    } else {
                        participant.isChecked = false; 
                    }

                    // if (participant.sentdate === null) {participant.sentdate = "Not Sent"};
                    return participant
                })
            } 
            if (fromPage === "PicPeople") {   /* note, disposition can be existing, new, or delete */
                updatedParticipants = participants.map(participant  => { 
                    participant.disposition = "existing"; 
                    // if (participant.sentdate === null) {participant.sentdate = "Not Sent"};
                    return participant ;
                })
            }
            dispatch(updateParticipants(participants));
        }).catch ((error) => {  /* TBD - this error should be logged to database */
            console.log(`Error encountered while trying to get list of participants from  in PicMuiTabs component`);
            console.log(error);
            dispatch(picAppError(`Problem: something went wrong fetching list of participants; Try again later `))
        });
    }
};

// Note that the single version of the truth for partcipants array, is redux, hence
// why  particpantArray is passed to this function so it can update redux with copy
// of array that has new participant entry.
// export const startAddNewParticipant = (newParticipantObject, participantsArray) => {
//     return (dispatch, getState ) => {
//         let self = this;

//         /* add the property attending: false to the newParticipantObject */
//         newParticipantObject.attending = false;
        
//         // Pull out x-auth token 
//         let userToken = getState().auth.token;

//         /*Construct url for api call and set up header */
//         let url    = getAppConfigParm("picUrl") + '/event/participant'; 
//         let header = getAppConfigParm("axiosConfig", userToken);

//         // /* Make api call to update database */
//         axios.post(url, newParticipantObject, header, )
//             .then(function (response) {
//             let participants = response.data.participants || [];
//             /* update the participants array in local storage */ 
//             dispatch(updateParticipants(participantsArray));
//             /* update contacts with new partcipant only if addToContacts is set to true (does not exist in contact list) */
//             let {email, name, addToContacts } = newParticipantObject;    /* pull out email, name, and addToContacts flag */
//             if (addToContacts === "yes") {
//                 let contactsCopy = getState().contacts.list;  /* make copy of contacts array */
//                 contactsCopy.unshift({email, name});          /* add partcipant to front of copy of contacts array */
//                 dispatch(updateContacts(contactsCopy));       /* dispatch event to update contacts with modified copy */
//             }
//         }).catch ((error) => {  /* TBD - this error should be logged to database */
//             console.log(`Error encountered while trying to add new participant`);
//             console.log(error);
//             dispatch(picAppError(`Problem: Server busy while trying to add entry for email '${newParticipantObject.email}'; Please try again later :no `))
//         });
//     }
// };

/* Update the database with latest updates to participant.list on redux store. Note that the  api call
   will also add and delete participants on the contacts collection . Upon successful  completion, 
   make updates to reflect changes in participant list to match database, and lastly, it updates contacts 
   list to reflect any adds / deletes to contact list on redux store */ 
export const startUpdateParticipantList = (participantList, nextScreen) => {

    return (dispatch, getState ) => {
       
        // Pull out x-auth token 
        let userToken = getState().auth.token;

        // Construct request object 
        let organizerEmail = getState().auth.user.email;
        let event_id       = getState().event.active._id;
        let requestObject  = { event_id, organizerEmail, participantList};

        /*Construct url for api call and set up header */
        // let url    = getAppConfigParm("picUrl") + '/event/participants'; 
        let header = getAppConfigParm("axiosConfig", userToken);

        let updateParticipantList = new PicPostRequest("updateParticipantList")
            .setUserId(getState().auth.user.email)
            .setRequestBody(requestObject)
            .setUri('/event/participants')
            .setAuthToken(getState().auth.token)
            .setLogTrace(true);

        updateParticipantList.exec().then(() => {

            // get copy of participant list from redux store
            let reduxParticipantList = getState().participants.list;

            // Updates particapant list on redux store to reflect db updates
            /* filter out deletes */
            let listWithNoDeletes = reduxParticipantList.filter(participant => participant.disposition !== "delete"); 
            /* change all other dispostions to "existing" and set addToContacts to "no" (since db has been updated) */
            let listResetToExisting = listWithNoDeletes.map(participant => {
                participant.disposition = "existing";
                participant.addToContacts = "no";
                return participant;
            }); 
            console.log("  >> listResetToExisting ", listResetToExisting);
            dispatch(updateParticipants(listResetToExisting));

            // Updates contact list on redux store to reflect db updates
            /* create list of participants of just deletes */
            let listWithJustDeletes = reduxParticipantList.filter(participant => participant.disposition === "delete"); 
            /* get redux contact list */
            let reduxContactsList = getState().contacts.list;
            /* remove all contacts that are in the participant delete list */
            listWithJustDeletes.forEach((participant) => {
                let indexValue =  reduxContactsList.findIndex(contact => contact.email === participant.email);
                if (indexValue > -1) {
                    reduxContactsList.splice(indexValue, 1)
                }
            })
            dispatch(updateContacts(reduxContactsList));
            
            console.log("NEXT SCREEN IS ", nextScreen);

            if (nextScreen !== 'none') { 
                console.log("NEXT SCREEN IS NOT EQUAL TO 'none' ");
                console.log("WE ARE NOW FIRING OFF HISTORY.PUSH ");
                history.push(nextScreen) 
            };

        }).catch((error) => {
            console.log(error) 
            console.log(updateParticipantList.getError())
        });
    } /* end of return (dispatch */
}; /* end of startUpdateParticipantList */



// export const startDeleteParticipants = (newParticipantObject, participantsArray) => {
//     return (dispatch, getState ) => {
//         let self = this;

//         trace && prtStart(compName, 'startAddNewParticipant');
//         trace && prtMsg('Below both input parameters');
//         trace && prtObjVar('newParticipantObject', newParticipantObject)
//         trace && prtObjVar('participantsArray', participantsArray)

//         trace && prtMsg('Pull out xauth token and event_id')
//         // Pull out x-auth token 
//         let userToken = getState().auth.token;

//         trace && prtVar('userToken', userToken);

        
//         /*Construct url for api call and set up header */
//         let url    = getAppConfigParm("picUrl") + '/event/participant'; 
//         let header = getAppConfigParm("axiosConfig", userToken);

//         trace && prtVar('URL', url);
//         trace && prtObjVar('Header', header);
        
//         // /* Make api call to delete token from database */
//         axios.post(url, newParticipantObject, header, )
//             .then(function (response) {
//             trace && prtMsg("Added new participant to database; below is participants array");
//             let participants = response.data.participants || [];
//             trace && prtObjVar('participantsArray', participantsArray);
//             trace && prtMsg("Now replacing participant array in redux store");    
//             dispatch(updateParticipants(participantsArray));
//             // dispatch(addNewParticipant(newParticipantObject));
//             if (getState().picapp.error) { dispatch(clearPicAppError()); } /* clear error if one exist*/
//         }).catch ((error) => {  /* TBD - this error should be logged to database */
//             console.log(`Error encountered while trying to add new participant`);
//             console.log(error);
//             dispatch(picAppError(`Problem: something went wrong with delete operation; try again, If fails again, please post comment on home page`))
//         });
//         trace && prtEnd(compName, 'startAddNewParticipant');
//     }
// };


// Note, although this is delete function, I have decided to use a POST because its acting as 
// a controller resource and axios delete does not take a request parameter. In addition, this 
// is not necessarily deleting participants but updating the participants list (effectively updating the array),
// then goes ahead and deletes from contact list. Although it is recommended to use POST with 
// controller resources and POST denotes non-idempotent, call is in fact idempotent.
// export const startDeleteParticipants = (participantsDeleteObj) => {
//     return (dispatch, getState ) => {
//         let self = this;

//         /* console.log object passed in */

//         /* pull out x-auth token */
//         let userToken = getState().auth.token;
        
//         /*Construct url for api call and set up header */
//         let url    = getAppConfigParm("picUrl") + '/event/participants'; 
//         let header = getAppConfigParm("axiosConfig", userToken);
        
//         /* Make api call to delete participants from participants collection and 
//               same participants from contacts collection; both dispatch statments
//               below take care of update the redux / local storage
//         */
//         axios.post(url, participantsDeleteObj, header )
//             .then(function (response) {
//             let deleteList = response.data.contactDeleteList || [];
//             dispatch(updateParticipants(participantsDeleteObj.participantList));
//             dispatch(startDeleteContacts(participantsDeleteObj.contactDeleteList));
//             // dispatch(addNewParticipant(newParticipantObject));
//             if (getState().picapp.error) { dispatch(clearPicAppError()); } /* clear error if one exist*/
//         }).catch ((error) => {  /* TBD - this error should be logged to database */
//             console.log(`Error encountered while trying to delete participant(s)`);
//             console.log(error);
//             dispatch(picAppError(`Problem: something went wrong with delete; Please try again later.`))
//         });
//     }
// };


// Action creator to add new participant (which effectively replaces the array in reduxx store)
// export const addNewParticipant = (selected) => ({
//     type: 'ADD_NEW_PARTICIPANT',
//     selected
// });

// Action creator to get participants
export const getParticipants = (participants) => ({
    type: 'GET_PARTICIPANTS' ,
    participants
});

// Action creator to update participants
// export const updateParticipants = (list) => ({
//     type: 'UPDATE_PARTICIPANTS',
//     list
// });
export const updateParticipants = (list) => {
    return {
        type: 'UPDATE_PARTICIPANTS',
        list
    }
};


// Action creator for setting the email value to use when rendering PicContactsAutosuggest
// and PicInvites
export const setAutosuggestEmailValue = (email = '') => ({
    type: 'SET_AUTO_SUGGEST_EMAIL_VALUE',
    email
});




// WEBPACK FOOTER //
// ./src/actions/participants.js